<template>
  <view-container title="Your Account">
    <template v-slot:heading>
      You are logged in
    </template>

    <template v-slot:default>
      <form
        action="/"
        class=" m-auto max-w-xs pb-4 text-base text-center u-spaceitems "
        @submit.prevent="logout"
      >
        <button
          type="submit"
          class="o-obvious-button py-3 px-6"
          data-test="logoutButton"
        >
          Log out
        </button>
      </form>
    </template>

    <template v-if="battle" v-slot:after>
      or
      <a href="/" @click.prevent="$router.back()" class="py-4 inline-block">
        go back
      </a>
    </template>
  </view-container>
</template>

<script>
import firebase from '@/utilities/firebase-config'
import ViewContainer from '@/components/ViewContainer'
import { mapGetters } from 'vuex'

export default {
  name: `account`,
  components: {
    ViewContainer,
  },
  computed: {
    ...mapGetters(`battles`, [`battle`]),
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(
          () => this.$router.replace(`home`),
          err => alert(`Oopsi-daisy. ${err.message}`)
        )
    },
  },
}
</script>
